module.exports = {"welcome-page-2":"Bine ai venit pe pagina 2","Hi people":"Buna lume","Welcome to your new Gatsby site.":"Bine ati venit pe noul dvs. site Gatsby.","Now go build something great.":"Construiti ceva grozav.","/page-2":"/ro/page-2","Go to page 2":"La pagina 2","Hi from the second page":"Salut de pe pagina a doua","/":"/ro/","Go back to the homepage":"Inapoi la pagina de acasa","open today":"Heute geöffnet","closed today":"Heute geschlossen","Webcam image":"Der strand Heute"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/de/messages.json
// module id = 215
// module chunks = 114276838955818 152176518627018